import './index.scss';
import { lang } from '@umu/ukit-lang';
import React, { useEffect, useState } from 'react';
import { If, IfShow } from 'common/src/components';
import { IClosePermissionInfo, IPermissionSettingDataInfo } from '../../interface';
import { contentPermissionMap } from './content';
import { PERMISSION_CONTENT_TYPE } from './interface';
import { Button, Iconfont } from '@umu/umu-design';
import { ISearchItem } from '../../../searchInput';
import { getCheckNavPermission } from '../../server';
import { onEditorPermission, onTransformParams } from './dataFlow';
import merge from 'lodash/merge';
import { Account } from '../../../../@utils/normalizeAccount';

interface IProps {
    prefixCls?: string;
    isOnlyShowValid?: boolean;
    dataInfo: IPermissionSettingDataInfo;
    closeInfo?: IClosePermissionInfo;
    accountList?: ISearchItem[];
    tipsTitle?: string | JSX.Element;
    customParams?: Record<string, string>;
    normalizeAccountEPU?: (account: Account) => string;
    normalizeAccountName?: (account: Account) => string;
}
const defaultCloseInfo = {
    list: [],
    isAll: false,
};
const PermissionContentInfo = (props: IProps) => {
    const {
        dataInfo: { navInfo, permissionValue },
        closeInfo = defaultCloseInfo,
        accountList = [],
        customParams,
        isOnlyShowValid = false,
        tipsTitle = '',
        prefixCls = 'permission-content-info',
        normalizeAccountEPU,
        normalizeAccountName,
    } = props;
    const { related_content_id = '0', related_type } = navInfo;
    const [isShowTips, setIsShowTips] = useState(false);
    const renderContent = () => {
        if (String(related_content_id) === '0' || !related_content_id) {
            return lang('尚未关联内容');
        }
        const Element = contentPermissionMap?.[related_type as PERMISSION_CONTENT_TYPE]?.content;
        return (
            <div>
                {Element && (
                    <Element
                        id={related_content_id}
                        seId={navInfo.se_id}
                        showRefresh={isShowTips}
                        normalizeAccountEPU={normalizeAccountEPU}
                        normalizeAccountName={normalizeAccountName}
                    />
                )}
            </div>
        );
    };
    const getPermissionCheck = () => {
        const list = onTransformParams(accountList, closeInfo.list);
        const params = merge(
            {},
            {
                nav_id: navInfo.id,
                se_id: navInfo.se_id,
            },
            !!customParams
                ? customParams
                : {
                      new_access_permission: permissionValue,
                      accounts: JSON.stringify(list),
                      is_delete_all: closeInfo.isAll ? '1' : '0',
                  },
        );
        getCheckNavPermission(params).then(({ isPass }) => {
            setIsShowTips(!isPass);
        });
    };
    useEffect(() => {
        getPermissionCheck();
    }, [permissionValue, accountList, closeInfo]);

    return isOnlyShowValid && !isShowTips ? null : (
        <div className={prefixCls}>
            <If condition={!isOnlyShowValid}>
                <div>{renderContent()}</div>
            </If>
            <IfShow show={isShowTips}>
                <div
                    className={`${prefixCls}-tips-content ${prefixCls}-tips-content-${
                        isOnlyShowValid ? 'border' : 'text'
                    }`}
                >
                    {tipsTitle}
                    <p className={`${prefixCls}-tips-content-desc`}>
                        <Iconfont type="ExclamationCircleFilled" className="icon-error" />
                        <span>
                            {lang('存在用户具有导航权限，但不具有内容权限；这些用户将无法查看导航关联的页面内容')}
                        </span>
                    </p>
                    <div className={`${prefixCls}-tips-content-operate`}>
                        <span className={`${prefixCls}-tips-content-operate-desc`}>{lang('您可以去')}</span>
                        <Button type="text" isOnlyChildren onClick={() => onEditorPermission(navInfo)}>
                            {lang('更改内容权限')}
                        </Button>
                    </div>
                </div>
            </IfShow>
        </div>
    );
};
export { PermissionContentInfo };
